export default __webpack_public_path__ + "static/media/Provider_license.2b870888.svg";